import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
var render = function render() {
  var _vm$departureWarehous, _vm$departureWarehous2;
  var _vm = this,
    _c = _vm._self._c;
  return _vm.gettingList.results.totalCount > 0 || ((_vm$departureWarehous = _vm.departureWarehousesAvailableForNewTransfer) === null || _vm$departureWarehous === void 0 ? void 0 : _vm$departureWarehous.length) > 0 ? _c("div", {
    staticClass: "--one-column mb-4"
  }, [_c("div", [_c("div", {
    staticClass: "title-small",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between"
    }
  }, [_vm._m(0), ((_vm$departureWarehous2 = _vm.departureWarehousesAvailableForNewTransfer) === null || _vm$departureWarehous2 === void 0 ? void 0 : _vm$departureWarehous2.length) > 0 ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    staticStyle: {
      "margin-left": "0.6rem"
    },
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.openCreate();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Add domestic transfer ")], 1) : _vm._e()], 1), _c("div", {
    staticStyle: {
      "text-align": "end"
    }
  }, [_c(VDataTable, {
    staticClass: "elevation-2 --background-transparent --no-shadow --border-1 cursor--pointer",
    attrs: {
      headers: _vm.gettingList.results.headers,
      items: _vm.gettingList.results.items,
      "hide-default-footer": "",
      "footer-props": {
        options: {
          itemsPerPage: -1
        }
      },
      "disable-pagination": "",
      "disable-sort": ""
    },
    on: {
      "click:row": _vm.rowClick
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function fn(_ref) {
        var _Object$values$find;
        var item = _ref.item;
        return [_c("div", [_c("svg", {
          staticClass: "icon icon-xxs dot mr-1",
          class: [_vm.getStatusClass(item)],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]), _vm._v(" " + _vm._s((_Object$values$find = Object.values(_vm.STOCK_TRANSFER_DOMESTIC.STATUS).find(function (x) {
          return x.id === item.status;
        })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.name) + " ")]), _c("div", {
          staticClass: "text-smaller"
        }, [item.status === _vm.STOCK_TRANSFER_DOMESTIC.STATUS.CANCELLED.id ? _c("span", [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.cancellationDate)) + " ")]) : _vm.STOCK_TRANSFER_DOMESTIC.STATUS.DELIVERED.id ? _c("span", [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.deliverhDate)) + " ")]) : _c("span", [_vm._v(_vm._s(_vm._f("formatDate_string")(item.creationDate)))])])];
      }
    }, {
      key: "item.fromWarehouse",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.fromWarehouse.name) + " ")];
      }
    }, {
      key: "item.toWarehouse",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.toWarehouse.name) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c("div", {
          staticClass: "td-without-link --inline-actions",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", {
          staticClass: "table-actions"
        }, [item.status === _vm.STOCK_TRANSFER_DOMESTIC.STATUS.CANCELLED.id ? _c("div", {
          staticClass: "text-italic"
        }, [_c("div", [_vm._v("CANCELLED")])]) : item.status === _vm.STOCK_TRANSFER_DOMESTIC.STATUS.DELIVERED.id ? _c("div", {
          staticClass: "text-italic"
        }, [_c("div", [_vm._v("DELIVERED")]), _c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDate_string")(item.deliveryDate)) + " ")])]) : [_c("a", {
          attrs: {
            href: "#",
            disabled: item.isBusy
          },
          on: {
            click: function click($event) {
              return _vm.rowClick(item);
            }
          }
        }, [_vm._v("Details / Edit")])]], 2)])];
      }
    }], null, true)
  })], 1)]), _c(VDialog, {
    attrs: {
      persistent: "",
      width: "800"
    },
    model: {
      value: _vm.creatingTransfer.isConfiguring,
      callback: function callback($$v) {
        _vm.$set(_vm.creatingTransfer, "isConfiguring", $$v);
      },
      expression: "creatingTransfer.isConfiguring"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.creatingTransfer.isPending
    },
    on: {
      click: _vm.cancelCreate
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Create domestic transfer")])]), _c("div", {
    staticClass: "content-centered large"
  }, [_c(VForm, {
    staticClass: "dfwa-form",
    on: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    },
    model: {
      value: _vm.creatingTransfer.form.isValid,
      callback: function callback($$v) {
        _vm.$set(_vm.creatingTransfer.form, "isValid", $$v);
      },
      expression: "creatingTransfer.form.isValid"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.departureWarehousesAvailableForNewTransfer,
      "item-value": "id_warehouse",
      "item-text": "name",
      label: "Warehouse departure of transfer, to consolidate to ".concat(_vm.order.warehouseName),
      "hide-details": "auto",
      required: "",
      rules: [_vm.formRules.mustSelectValue],
      filter: _vm.filterVAutocomplete
    },
    model: {
      value: _vm.creatingTransfer.form.departureWarehouseIdOfItems,
      callback: function callback($$v) {
        _vm.$set(_vm.creatingTransfer.form, "departureWarehouseIdOfItems", $$v);
      },
      expression: "creatingTransfer.form.departureWarehouseIdOfItems"
    }
  }), _c("div", [_c(VSwitch, {
    staticClass: "v-text-field-no-label",
    attrs: {
      label: _vm.creatingTransfer.form.isImmediateTransfer ? "Will create an immediate transfer, like the products are already in the right warehouse" : "Will create a pending transfer, a reception validation will be required later",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creatingTransfer.form.isImmediateTransfer,
      callback: function callback($$v) {
        _vm.$set(_vm.creatingTransfer.form, "isImmediateTransfer", $$v);
      },
      expression: "creatingTransfer.form.isImmediateTransfer"
    }
  })], 1), _c("div", {
    staticClass: "flex justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      text: "",
      disabled: _vm.isAnyActionInProgress
    },
    on: {
      click: function click($event) {
        return _vm.cancelCreate();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-times mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small highlight",
    attrs: {
      rounded: "",
      disabled: !_vm.creatingTransfer.form.isValid,
      loading: _vm.creatingTransfer.isPending
    },
    on: {
      click: function click($event) {
        return _vm.create();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-save mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), _vm._v(" Save ")], 1)], 1)], 1)], 1)], 1)], 1), _vm.editedId > 0 ? _c("StockTransferDomesticFormModal", {
    ref: "stockTransferDomesticForm",
    attrs: {
      id: _vm.editedId
    },
    on: {
      entityUpdated: function entityUpdated($event) {
        return _vm.stockTransferEntityUpdated();
      },
      closed: function closed($event) {
        return _vm.formClosed();
      }
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("i", {
    staticClass: "fas fa-route",
    staticStyle: {
      "font-size": "1rem"
    }
  }), _vm._v(" Domestic transfers ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };